export default {
    GET_TOKEN(state) {
        if (localStorage.getItem('identity') != null) {
            state.token = JSON.parse(localStorage.getItem('identity'));
        }
        return state.token;
    },
}